import { Spinner } from "@/components/ui/spinner"

type LoaderProps = {
  className?: string
  small?: boolean
}
const Loader = ({ className, small }: LoaderProps) => (
  <div className={className}>
    <Spinner size={small ? "sm" : "md"} />
  </div>
)

export default Loader
